import * as React from "react"
import { cn } from "../../lib/utils"

const Modal = React.forwardRef(({ className, isOpen, onClose, disableBackdropClose = false, disableEscapeClose = false, children, ...props }, ref) => {
  const modalRef = React.useRef(null);

  React.useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape' && !disableEscapeClose) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose, disableEscapeClose]);

  const handleBackdropClick = (event) => {
    if (!disableBackdropClose && modalRef.current && !modalRef.current.contains(event.target)) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={handleBackdropClick}
    >
      <div
        ref={modalRef}
        className={cn(
          "w-full max-w-4xl mx-4 bg-white rounded-lg shadow-lg",
          className
        )}
        {...props}
      >
        {children}
      </div>
    </div>
  )
})
Modal.displayName = "Modal"

const ModalHeader = React.forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("px-6 py-4 border-b border-gray-200", className)}
    {...props}
  >
    {children}
  </div>
))
ModalHeader.displayName = "ModalHeader"

const ModalBody = React.forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("px-6 py-4", className)}
    {...props}
  >
    {children}
  </div>
))
ModalBody.displayName = "ModalBody"

const ModalFooter = React.forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("px-6 py-4 border-t border-gray-200 flex justify-end space-x-2", className)}
    {...props}
  >
    {children}
  </div>
))
ModalFooter.displayName = "ModalFooter"

export { Modal, ModalHeader, ModalBody, ModalFooter }